import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';

import { PERSONAL_ACCOUNT_ACTIONS_NAME, PERSONAL_ACCOUNT_MUTATIONS_NAME } from './name';
import { TPersonalAccountCochairState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function fetchCountries(context: ActionContext<TPersonalAccountCochairState, unknown>) {
  if (context.state.listOfCountry.items.length > 0) return;

  context.commit('setIsLoading', true);

  const res = await request(
    context,
    {
      url: links.mpkcochairman.fetchCountries,
      mutate: PERSONAL_ACCOUNT_MUTATIONS_NAME.setListOfCountry,
      name: PERSONAL_ACCOUNT_ACTIONS_NAME.fetchCountries,
    },
    {
      pageSize: context.state.listOfCountry.pageSize,
      pageNumber: context.state.listOfCountry.pageNumber,
    },
  );

  context.commit('setIsLoading', false);

  return res;
}

export async function fetchMoreCountries(
  context: ActionContext<TPersonalAccountCochairState, unknown>,
  payload: TBaseFilterPayload<TPaginationParams>,
) {
  context.commit('setIsLoadingMore', true);

  const res = await request(
    context,
    {
      url: links.mpkcochairman.fetchCountries,
      mutate: PERSONAL_ACCOUNT_MUTATIONS_NAME.setMoreListOfCountry,
      name: PERSONAL_ACCOUNT_ACTIONS_NAME.fetchCountries,
    },
    {
      pageSize: context.state.listOfCountry.pageSize,
      pageNumber: payload.params.pageNumber,
    },
  );

  context.commit('setIsLoadingMore', false);

  return res;
}
